<template>
  <div class="col-md-12" v-if="campaign">
    <label class="form-control-label">
      <h4>Campaign Duration</h4>
    </label>
    <label class="d-inline mx-10 form-control-label"> Start </label>
    <div class="d-inline mx-10">
      <DatePicker
        type="date"
        width-150px
        placeholder="n/a"
        ref="start_date"
        format="YYYY-MM-DD"
        value-type="YYYY-MM-DD"
        :disabled="disabled"
        v-model="campaign.start_date"
        @change="update('start_date')"
        :disabled-date="disabledBeforeTomorrow"
      />
    </div>
    <label class="d-inline mx-10 form-control-label"> End </label>
    <div class="d-inline mx-10">
      <DatePicker
        type="date"
        width-150px
        placeholder="n/a"
        ref="end_date"
        format="YYYY-MM-DD"
        value-type="YYYY-MM-DD"
        :disabled="disabled"
        v-model="campaign.end_date"
        @change="update('end_date')"
        :disabled-date="disabledBeforeStart"
      />
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import DatePicker from "vue2-datepicker";
import { progressBarService } from "@/api/client";

export default {
  props: ["campaign"],

  components: {
    DatePicker,
  },

  data() {
    return {
      oldValue: null,
    };
  },

  computed: {
    disabled() {
      return this.campaign.status != "draft";
    },
  },

  mounted() {
    const { start_date, end_date } = this.campaign;
    this.oldValue = { start_date, end_date };
  },

  methods: {
    disabledBeforeTomorrow(date) {
      const tomorrow = dayjs().add(1, "days").toDate();
      tomorrow.setHours(0, 0, 0, 0);
      return date < tomorrow;
    },

    disabledBeforeStart(date) {
      const startDate = new Date(this.campaign.start_date);
      startDate.setHours(0, 0, 0, 0);
      return date < startDate;
    },

    async isFormValid(key) {
      if (
        key == "start_date" &&
        dayjs(this.campaign.start_date).diff(
          new Date().setHours(0, 0, 0, 0),
          "days"
        ) < 1
      ) {
        await this.$dialogs.alert(
          "Start date ใส่ค่าได้ตั้งแต่วันที่ในอนาคตเท่านั้น"
        );
        this.$refs.start_date.focus();

        const { start_date, end_date } = this.oldValue;
        this.setDefaultValues(start_date, end_date);

        return false;
      }

      if (dayjs(this.campaign.start_date) > dayjs(this.campaign.end_date)) {
        await this.$dialogs.alert(
          "กรุณาระบุวันเริ่มที่น้อยกว่าวันสิ้นสุด campaign"
        );
        const { start_date, end_date } = this.oldValue;
        this.setDefaultValues(start_date, end_date);

        return false;
      }

      return true;
    },

    async update(key) {
      try {
        const formValid = await this.isFormValid(key);
        if (!formValid) return;

        const { id, start_date, end_date } = this.campaign;
        const form = {
          end_date: dayjs(end_date || start_date).format("YYYY-MM-DD 23:59:59"),
          start_date: dayjs(start_date || end_date).format(
            "YYYY-MM-DD 00:00:00"
          ),
        };

        await progressBarService.updateCampaignInfo(id, form);

        this.oldValue = { start_date, end_date };

        this.$emit("updated");
        this.$notify(`Campaign Duration updated.`);
      } catch (error) {
        this.$dialogs.alert(`Campaign Duration update error.`);
      }
    },

    setDefaultValues(start, end) {
      this.campaign.end_date = end;
      this.campaign.start_date = start;

      this.duration = dayjs(new Date(end)).diff(new Date(start), "days") + 1;
    },
  },
};
</script>

<style></style>
